import React, { useEffect, useState } from "react";
import { ExamLabel } from "../../components/commons";
import { List, Spin, Result, Button, Empty } from "antd";
import * as SHARED from "../../utils/shared";
import { getSorteosPublic } from "../../api/sorteo";
import { Link } from "react-router-dom";
import moment from "moment";

function SorteoPublic(props) {
  const [dataToTable, setDataToTable] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);

  const fetchDataToTable = async () => {
    try {
      setIsLoading(true);
      const res = await getSorteosPublic();
      // console.log("sorteos", res.payload);
      setDataToTable(res.payload);
    } catch (error) {
      setError(error);
      setIsError(true);
      setDataToTable([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDataToTable();
  }, []);

  if (isLoading) {
    return <Spin tip="Cargando" className="w-full py-60" />;
  }

  if (isError) {
    return (
      <Result
        status="500"
        title="Algo salió mal"
        subTitle={error.message}
        extra={
          <Button onClick={() => window.location.reload()} type="primary">
            Recargar
          </Button>
        }
      />
    );
  }

  return (
    <div className="max-w-md mx-auto">
      <ExamLabel
        firstTitle={`RESULTADOS DE SORTEOS`}
        mainTitle={SHARED.PROCESO}
        style={{ background: "#D41D3D" }}
      />

      {!dataToTable.length ? (
        <Empty description="Sin sorteos para mostrar" />
      ) : (
        <List
          size="large"
          bordered
          dataSource={dataToTable}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                title={
                  <Link to={"/sorteo/" + item.codigo}>
                    <h4 className="hover:text-red-500">{item.nombre}</h4>
                  </Link>
                }
                description={
                  <p className="">
                    Fecha sorteo:&nbsp;
                    {moment(item.fecha).format("DD/MM/YYYY hh:mm A")} | Código: {item.codigo}
                  </p>
                }
              />
            </List.Item>
          )}
        />
      )}
    </div>
  );
}

export default SorteoPublic;
